import './App.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import React, {useEffect} from 'react';
import {AuthService} from './services/AuthService';
import AppRoutes from './routes';
import { useNavigate } from 'react-router-dom';
import {setUserData, is401Error } from "./util/auth-validation";
import { createRoot } from "react-dom/client";
import PleaseWait from "./components/CFAdminWait";
import {MsalProvider, useMsal} from "@azure/msal-react";
import {InteractionStatus, PublicClientApplication} from "@azure/msal-browser";
import { msalConfig } from './auth-config';
import { retrieveAccessToken } from './util/msal-config';
import Loader from "./components/CFAdminLoader";
import { PROVIDER_APP_ID } from './util/environment';

// Use PROVIDER_APP_ID directly
console.log("PROVIDER_APP_ID:", PROVIDER_APP_ID);
// @ts-ignore
export const msalInstance = new PublicClientApplication(msalConfig);

// Create a div to render the PleaseWait component
const pleaseWaitDiv = document.createElement('div');
document.body.appendChild(pleaseWaitDiv);
createRoot(pleaseWaitDiv).render(<PleaseWait/>);

function App() {
    const itemKey = "msal.interaction.status";
    const loginRequest = {
        scopes: [`api://${PROVIDER_APP_ID}/.default`]
    };
    const [load, setLoad] = React.useState(true);
    const [user, setUser] = React.useState({ssoUserDetails:'',promoteFlag:'',canBatchAccess: '',canSystemMaintenance:'',
        canDataPublish: '', canGSMOperations: '', canTestClients: '', canDataAdmin: '', canVinImport: '', canVinValidate: '',  canVinPublish: '', authorised: ''});
    const navigate = useNavigate();

    const { inProgress } = useMsal();

    const handleLogin = async () => {
        if (inProgress === InteractionStatus.None) {
            try {
                if (sessionStorage.getItem(itemKey)) {
                    sessionStorage.removeItem(itemKey);
                }
                await msalInstance.loginRedirect(loginRequest);
            } catch (error) {
                console.error("Error during login:", error);
            }
        } else {
            console.warn("Interaction already in progress. Please wait.");
        }
    };


    useEffect(() => {
        const fetchAccessToken = async () => {
            try {
                await retrieveAccessToken(handleLogin);
                getUserDetails();
            } catch (error) {
                console.error('Error retrieving access token:', error);
            }
        };
        fetchAccessToken();
    }, []);


// Helper function to update user data
const updateUserData = async (data: any) => {
  await setUserData(data);
  setUser({
    ...user,
    ssoUserDetails: data.ssoUserDetails,
    canBatchAccess: data.canBatchAccess,
    canSystemMaintenance: data.canSystemMaintenance,
    canDataAdmin: data.canDataAdmin,
    canDataPublish: data.canDataPublish,
    canGSMOperations: data.canGSMOperations,
    canTestClients: data.canTestClients,
    canVinImport: data.canVinImport,
    canVinValidate: data.canVinValidate,
    canVinPublish: data.canVinPublish,
    authorised: data.authorised,
  });
  setLoad(false);
  if (data.authorised) {
    console.log("Navigating to Home - ");
    navigate('/');
  } else {
    console.log("Navigating to Access Restrict - ");
    navigate('/accessrestrict');
  }
};

  const getUserDetails = async () => {
    setLoad(true);
    AuthService.getUserDetails()
        .then(response => {
          if (response.data) {
            console.log("setting user - ");
            updateUserData(response.data);
          }
        })
        .catch(e => {
          console.log(e);
          is401Error(e).then(res => {
            if (res) {
              console.log("401 error - ");
              setLoad(false);
              handleLogin();
            } else {
              console.log("Error - ", e);
            }
          });
        });
  };

  return (
      <MsalProvider instance={msalInstance}>
          <HelmetProvider>
            <Helmet>
              <title>Maintenance Schedule Pricing</title>
            </Helmet>
              {load ? <Loader message={'User Authentication'}/>  : <AppRoutes {...user}  />}
          </HelmetProvider>
      </MsalProvider>
  );
}

export default App;
